module.exports = __webpack_public_path__ + "files/3e0b06cea3f36b0dfe251d0be51f0436.png";